import { isInIframe } from '../../scheduleMeeting/utils/iframe';

export { isInIframe };

/**
 * Sends height update to parent window for iframe resize
 */
export function sendHeightToParent(): void {
	if (!isInIframe()) {
		return;
	}

	const height = document.body.scrollHeight;
	// '*' target origin is intentional — events pages can be embedded on any customer's website
	window.parent.postMessage({ type: 'levitate-events-height', height }, '*');
}
